import { createService } from '@bonanza-social/toolkit/api';
import { FreeSpinsResponseSchema } from './RewardsService.schemas';

export default createService(
  {
    getFreeSpins: {
      method: 'GET',
      url: '/rewards/freespins',
      responseSchema: FreeSpinsResponseSchema,
    },
  },
  ({ userId }) => `/Players/${userId}`,
);
